import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "mkJaUvNOfU",
				"width": 401.9,
				"height": 68.984375,
				"left": 518.8523624366678,
				"top": 169.64119543124775,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#fff",
				"content": `<p style=\"text-align: left;\"><span style=\"font-size: 48.98px;font-family: +mn-ea;\">谢谢观看</span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "shape",
				"id": "JL6Y3tZFFe",
				"width": 406.54,
				"height": 370.17,
				"left": 93.46,
				"top": 96.17,
				"viewBox": [
					406.54,
					370.17
				],
				"path": " M0,0 L406.5384678477691,0 L406.5384678477691,5.463597306906372 L5.488166805452876,5.463597306906372 L5.488166805452876,364.70388956973403 L406.5384678477691,364.70388956973403 L406.5384678477691,370.1674868766404 L0,370.1674868766404z",
				"fill": "#c00000",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#600000",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 微软雅黑;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false,
				"special": true
			},
			{
				"type": "shape",
				"id": "RIBaXUEOW3",
				"width": 406.54,
				"height": 370.17,
				"left": 500,
				"top": 96.17,
				"viewBox": [
					406.54,
					370.17
				],
				"path": " M0,0 L406.5384678477691,0 L406.5384678477691,370.1674868766404 L0,370.1674868766404 L0,364.70388956973403 L400.89018509683706,364.70388956973403 L400.89018509683706,5.463597306906372 L0,5.463597306906372z",
				"fill": "rgba(0,0,0,1)",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#600000",
					"width": 0,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 18.37px;font-family: 微软雅黑;\">&nbsp;</span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false,
				"special": true
			},
			{
				"type": "text",
				"id": "cewL2REUIs",
				"width": 401.9,
				"height": 40.40625,
				"left": 518.8523624366678,
				"top": 327.7880947331212,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#fff",
				"content": "<p style=\"text-align: left;\"><span style=\"font-size: 20.41px;font-family: +mn-ea;\">20XX</span><span style=\"font-size: 20.41px;font-family: +mn-ea;\">年</span><span style=\"font-size: 20.41px;font-family: +mn-ea;\">XX</span><span style=\"font-size: 20.41px;font-family: +mn-ea;\">月版</span></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			}
		],
		background
	};

}